/*
|----------------------------------------------------------
|   Advertisement:
|---------------------------------------------------------
|   All functions related to Advertisements from any ad server
|   system (WBP, DFP, etc)
|
*/

/**
 * Import config
 */
import config from "./config";

export default {

    /**
     * Destroy DFP AD units on pjax
     */
    processAds: function() {

        var hostName = window.location.hostname
        console.log("HOST NAME: ", hostName);
        if(hostName == "wabcradio.com" || hostName == "wabcradioclone.onecmsdev.com"){
            if(typeof window.freestar !== 'undefined'){
                freestar.queue.push(function() {
                    freestar.deleteAdSlots();
                });
            }
            console.log("processAdsFreestar...")
        }
        else{
            if (window.googletag && googletag.apiReady) {

                if (config.debug) console.log("destroySlots LoadDFPBanner...");

                var googletagstatus;

                googletag.cmd.push(function() {
                    if (config.debug) console.log("googletag pubads start...");
                    googletag.pubads().clear();
                    googletag.pubads().clearTargeting();
                });

                googletagstatus = googletag.destroySlots();

                jQuery(".player-banner-ad").empty();

                if (config.debug) console.log("googletagstatus: ", googletagstatus);
            }
            console.log("processAds...")
        }
    },

    /**
     * TODO: FUNCTION DOCUMENTATION NEEDED FROM DEV TEAM
     */
    setTargetAds: function(data) {

        if (config.debug) {
            console.log("Pjax URL::: ", data);
            console.log("Pjax URL::: ", data.url);
        }
        // Set target key value for ad on pjax
        if (window.googletag && googletag.apiReady) {

            var randomNumber = Math.floor(Math.random() * (1000 - 1 + 1) + 1);
            var postId = "'" + randomNumber + "'";
            var pageName = "'Page Name - " + randomNumber + "'";
            var cat = "'Category Name - " + randomNumber + "'";

            if (config.debug) {
                console.log("Post ID: ", postId);
                console.log("Page Name: ", pageName);
                console.log("Category: ", cat);
            }

            googletag.cmd.push(function() {
                googletag.pubads().setTargeting('postid', [postId]);
                googletag.pubads().setTargeting('pageName', pageName);
                googletag.pubads().setTargeting('cat', [cat]);
                //googletag.pubads().setTargeting('change-'+randomNumber,[postId]);
            });

            if (config.debug) console.log("Set target DFP Banner End...");

        } else {

            console.log("googletag.apiReady is not ready...");

        }
    },

    /**
     * TODO: FUNCTION DOCUMENTATION NEEDED FROM DEV TEAM
     */
    swapDFPSetTarget: function(pjax) {
        if (config.debug) console.log('swapDFPSetTarget');
        var settargetDiv = jQuery(pjax.newDocument).find('#dfp-page-target-div')
        jQuery('#dfp-page-target-div').html(settargetDiv.html())

    },

    /**
     * TODO: FUNCTION DOCUMENTATION NEEDED FROM DEV TEAM
     */
    swapDFPPlayerBanner: function(pjax) {
        if (config.debug) console.log('swapDFPPlayerBanner');
        var swapPlayerBammer = jQuery(pjax.newDocument).find('.player-banner-ad');
        jQuery('.player-banner-ad').html(swapPlayerBammer.html())

    },

    /**
     * Process takeover ad banners
     */
    setTakeoverAds: function () {
        /**
         * Only run function if banners are in page and
         * the screen has enough space to show the ads
         */
        if (jQuery('#ad-takeovers').length && window.screen.width > 1024) {
            if (config.debug) console.log("setTakeoverAds");

            // Add required z-indexes to elements on the page
            jQuery('.content-wrapper').css({
                position: 'relative',
                zIndex: 2
            });
            jQuery('.elementor-location-header header, .elementor-location-footer footer, .elementor-location-footer .footer-section').css({
                position: 'relative',
                zIndex: 200
            });
            jQuery('.elementor-location-header #home-hero, .elementor-location-header .home-hero').css({
                position: 'relative',
                zIndex: 100
            });

        }

    }
}
